import { z } from "zod";
import { MAX_PAGE_SIZE } from "../constants/index.js";

export const paginationSchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(25),
});

export const idParamSchema = z.object({
  id: z.string().uuid(),
});

export const apiHealthSchema = z.object({
  data: z.object({
    status: z.enum(["ok", "degraded"]),
    version: z.string(),
    environment: z.string(),
    timestamp: z.string().datetime(),
  }),
});

export const apiErrorSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.record(z.array(z.string())).optional(),
  }),
});

export const listMetaSchema = z.object({
  resource: z.string(),
  companyId: z.string().uuid(),
  page: z.number().int(),
  pageSize: z.number().int(),
  total: z.number().int().optional(),
});

export type PaginationInput = z.infer<typeof paginationSchema>;
export type ApiHealthResponse = z.infer<typeof apiHealthSchema>;
